import { format } from 'date-fns';
import { IStatementBuilderMessage } from 'shared';

import { Button } from '../../../../../../common/Atoms/Button';
import { Paragraph } from '../../../../../../common/Atoms/Typography/Paragraph';
import { classNames } from '../../../../../../common/lib/classNames';

interface BuilderChatMessageProps {
  message: IStatementBuilderMessage;
  onRevert: (message: IStatementBuilderMessage) => void;
  disabled?: boolean;
}

export function BuilderChatMessage({
  message,
  onRevert,
  disabled = false,
}: BuilderChatMessageProps) {
  if (message.role === `system`) {
    return (
      <div className={ `flex justify-center` }>
        <Paragraph
          size={ `xs` }
          variant={ `secondary` }
          className={ `rounded-full bg-slate-100 px-3 py-1` }
        >
          { message.content }
        </Paragraph>
      </div>
    );
  }

  const isUser = message.role === `user`;
  const createdAt = message.createdAt ? format(new Date(message.createdAt), `PPp`) : ``;

  return (
    <div className={ classNames(`flex`, isUser ? `justify-end` : `justify-start`) }>
      <div className={ classNames(`max-w-[85%]`, isUser ? `items-end` : `items-start`, `flex flex-col gap-2`) }>
        <div
          className={ classNames(
            `whitespace-pre-wrap rounded-2xl px-4 py-3 text-sm shadow-xs`,
            isUser
              ? `bg-paidniceGreen-600 text-white`
              : `border border-slate-200 bg-white text-slate-800`,
          ) }
        >
          { message.content }
        </div>
        <div className={ classNames(`flex items-center gap-2`, isUser ? `justify-end` : `justify-start`) }>
          <Paragraph
            size={ `xs` }
            variant={ `secondary` }
          >
            { createdAt }
          </Paragraph>
          {
            !isUser && message.hasSnapshot &&
            <Button
              size={ `sm` }
              color={ `gray` }
              disabled={ disabled }
              onClick={ () => onRevert(message) }
              className={ `!bg-transparent !text-slate-600 hover:!bg-slate-100` }
            >
              { `Revert to here` }
            </Button>
          }
        </div>
      </div>
    </div>
  );
}
